import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { setMessageBySessionId } from '../../../state/message/messageSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* fetchMessageSaga(action) {
    const { messageSessionId } = action.payload;
  try {
    const { domain, user } = yield select(selectUserCredentials);
    const response = yield call(cirrusClient.get, `/v2/domains/${domain}/users/${user}/messagesessions/${messageSessionId}/messages`);
    yield put(setMessageBySessionId({ messageSessionId, messages: response.data }));
  } catch (error) {
    console.error('Error fetching messages:', error);
  }
}